import styled, { css } from "styled-components";
import theme from "~/styles/theme";

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    width: 90%;
  }
  button {
    width: 100%;
  }
    
  @media (min-width: ${theme.breakpoints.values.md}px) {
    > div {
      width: fit-content;
    }
  }
`;

export const PageContainer = styled.div`
  background: #F5F5F5;
`;

export const Title = styled.span`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%; /* 26.4px */
`;

export const TitleHolder = styled.div`
  padding: 0 16px;
  width: 100%;
  text-align: center;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 839px;
    margin: 0 auto;
  }

  p {
    color: ${theme.palette.neutral.primary.key};
    font-family: ${theme.typography.fontFamilyRegular};
    text-align: center;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin: 0 auto;
      max-width: 839px;
    }
  }

  strong {
    color: ${theme.palette.neutral.primary.key};
    text-align: center;
  }

  h1 {
    text-align: center;
  }
`;

export const SubTitleHolder = styled.div`
  h3 {
    text-align: center;
  }
`;

export const HolderBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextHolder = styled.div`
  max-width: 663px;
  margin: 0 auto;

  strong {
    font-family: ${theme.typography.fontFamily};
    text-align: center;
  }
`;

export const CardsHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 32px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 40px;
  }
`;

export const Card = styled.div`
  width: 156px;
  height: 187px;
  border-radius: 16px;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0 10px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  overflow: hidden;
  cursor: pointer;
  position: relative;

  &:hover {
    box-shadow: 0px 6px 10px 0px #02856b40;
  }

  ${(props) =>
    props.active &&
    css`
      span {
        border: 1px solid ${theme.palette.brand.primary.key};

        &::after {
          content: "";
          position: absolute;
          z-index: 1000;
          border: 1px solid ${theme.palette.neutral.primary.light};
          width: 15px;
          height: 15px;
          border-radius: 50%;
        }
      }
    `}

  span {
    position: absolute;
    left: 8px;
    top: 8px;
    width: 19px;
    height: 19px;
    background-color: ${(props) =>
      props.active
        ? theme.palette.brand.primary.key
        : theme.palette.neutral.primary.light};
    z-index: 100;
    border-radius: 50%;
    display: block;
    border: ${(props) =>
      props.active
        ? `1px solid ${theme.palette.brand.primary.key}`
        : `1px solid ${theme.palette.neutral.primary.light}`};

    @media (min-width: ${theme.breakpoints.values.md}px) {
      left: 18px;
      top: 7px;
    }
  }

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 250px;
    height: 230px;
  }
`;

export const BottomCard = styled.div`
  height: 53px;
  background-color: ${theme.palette.neutral.primary.light};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    height: 52px;
  }

  img {
    width: 60%;
    
    @media (min-width: ${theme.breakpoints.values.md}px) {
      width: auto;
    }
  }
`;



export const ContentModal = styled.div`
  cursor: default;
  text-align: center;
`;